import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Panel } from 'react-bootstrap';
import { fetchInmatriculacion } from '../../../../actions';

class Inmatriculacion extends Component {
  static hideMessage() {
    setTimeout(() => {
      if (document.getElementById('alertInmatriculacion')) {
        document.getElementById('alertInmatriculacion').style.display = 'none';
      }
    }, 3000);
  }

  constructor(props) {
    super(props);
    this.state = {
      mostrarPanel: false,
      iconAlert: '',
      mensajeAlert: '',
      listaInmatriCab: [],
      listaInmatriDet: [],
      mostrarFila: '',
    };
  }

  togglePanel = () => this.setState({ mostrarPanel: !this.state.mostrarPanel })
  togglePanel2 = (index) => {
    if (index === this.state.mostrarFila) {
      this.setState({ mostrarFila: '' });
    } else {
      this.setState({ mostrarFila: index });
    }
  }

  handleClickInmatriculacion() {
    this.props.fetchInmatriculacion(this.props.fdvID,this.props.selectPedido)
      .then((result) => {
        console.log(result);
        if (result.payload.data.estadoTrama === '1') { // ok
          this.setState({ listaInmatriCab: result.payload.data.inmatriculacionCab });
          this.setState({ listaInmatriDet: result.payload.data.inmatriculacionDet });
        } else if (result.payload.data.estadoTrama === '0') {
          this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: result.payload.data.mensaje });
          this.hideMessage();
        } else if (result.payload.data.estadoTrama === '-1') {
          this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: `¡Error interno del servidor:${result.payload.data.mensaje}!` });
          this.hideMessage();
        } else {
          this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: `¡Error interno del servidor:${result.payload.data.estadoTrama}!` });
          this.hideMessage();
        }
      });
  }

  componentDidMount(){
    this.handleClickInmatriculacion();
  }

  render() {
    return (
      <div>
        <section className='fdv-section tab-pane' id='inmatriculacion'>
          <header className='fdv-section-head'>
            <h5 className='fdv-section-title'>Inmatriculación</h5>
          </header>
          <div className='tableWrapper hidden-xs'>
            <table className='table table-hover'>
              <thead className='table-head'>
                <tr>
                  <th>Nº Pedido</th>
                  <th>Nº Título</th>
                  <th>Fecha</th>
                  <th>Días</th>
                  <th>F° Inscripción</th>
                  <th>Placa</th>
                  <th/>
                </tr>
              </thead>
              {this.state.listaInmatriCab.map((listaInmatriCab, index) => (
                <tbody key={index}>
                  <tr className='as' data-target='#kwq1' onClick={() => this.togglePanel2(index)}>
                    <td>
                      {listaInmatriCab.numPedVeh}
                    </td>
                    <td>
                      {listaInmatriCab.numTitulo}
                    </td>
                    <td>
                      {listaInmatriCab.fecTitulo}
                    </td>
                    <td>
                      {listaInmatriCab.numDias}
                    </td>
                    <td>
                      {listaInmatriCab.fecInscrip}
                    </td>
                    <td>
                      {listaInmatriCab.numPlaca}
                    </td>
                    <td>
                    <i className="ion-chevron-down ml-3 c-cyan"></i>
                    </td>
                  </tr>
                  <tr className='table-extra'>
                    <td colSpan='7'>
                      <Panel collapsible expanded={ true } style={{ borderColor: 'transparent', boxShadow: '0 0 0 white', margin: '0', backgroundColor: 'inherit' }} >
                        <div className='collapse in' id='kwq1'>
                          <div className='table-extra-wrap'>
                            <ul>
                              {
                                this.state.listaInmatriDet.filter(value => value.numPedVeh === listaInmatriCab.numPedVeh)
                                  .map((lista,index) => (
                                    <li className='clearfix' key={index}>
                                      <p className='pull-left' style={{marginLeft: '10px'}}>{lista.numSecuencia + ' '}</p>
                                      <p className='pull-left' style={{marginLeft: '10px'}}>{lista.desInmatri + ' '}</p>
                                      <p className='pull-right c-gray' style={{marginLeft: '10px'}}>{lista.fecInmatri} - {lista.horaInmatri + ' '}</p>
                                      <p className='pull-right c-gray' style={{marginLeft: '10px'}}>{lista.nomUsuario}</p>
                                    </li>
                                  ))
                              }
                            </ul>
                          </div>
                        </div>
                      </Panel>
                    </td>
                  </tr>
                </tbody>
              ))}
            </table>
          </div>
        </section>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    inmatriculacion: state.inmatriculacion
  };
}

export default withRouter(
  connect(mapStateToProps, {
    fetchInmatriculacion
  })(Inmatriculacion));



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/DetallePedido/ItemsDetalle/Inmatriculacion.js